import { logAndThrow } from "@/src/lib/logging/logger";

export enum MockedEhrVendor {
  ADVANCED_MD = "AdvancedMD",
  ATHENA = "Athena",
  CLINICIENT = "Clinicient",
  CLOUDCRUISE = "CloudCruise",
  COBALT = "Cobalt",
  FHIR = "FHIR",
  INSYNC = "InSync",
  MEDENT = "MEDENT",
  MOD_MED = "ModMed",
  NEXTGEN = "NextGen",
  SALESFORCE = "Salesforce",
  WEBECW = "webecw",
}

/** Whether `MOCK_EHR=true` routes every EHR call in this process to the mock instead of a real vendor. */
export function isEhrMockEnabled(): boolean {
  if (process.env.MOCK_EHR !== "true") return false;

  if (process.env.NODE_ENV === "production") {
    logAndThrow("MOCK_EHR must not be set in production", { nodeEnv: process.env.NODE_ENV });
  }

  return true;
}

/** Throws before a real vendor request leaves the process while `MOCK_EHR` is enabled. */
export function assertRealEhrAllowed(vendor: MockedEhrVendor, operation: string): void {
  if (!isEhrMockEnabled()) return;

  logAndThrow(`MOCK_EHR is enabled; refusing real ${vendor} request`, { vendor, operation });
}
